import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

import HttpIncidentExportFormHandler from './HttpIncidentExportFormHandler';

interface IHttpIncidentExportModalProps {
    open: boolean,
    handleClose: () => void,
}

const HttpIncidentExportModal: React.FC<IHttpIncidentExportModalProps> = ({open, handleClose}) => (
    <FiltersModal
        header={t`Экспорт инцидентов`}
        open={open}
        handleClose={handleClose}
        keepParams={FILTERS_KEPT_NONE}
        withReset={false}
    >
        <HttpIncidentExportFormHandler handleClose={handleClose}/>
    </FiltersModal>
);

export default HttpIncidentExportModal;
